import type { AgeGroup, Category, ScoringTable } from './types'
import { WHTR_TABLE } from './scoringTables'

export function getAG(age: number): AgeGroup {
  if (age < 25) return '<25'
  if (age < 30) return '25-29'
  if (age < 35) return '30-34'
  if (age < 40) return '35-39'
  if (age < 45) return '40-44'
  if (age < 50) return '45-49'
  if (age < 55) return '50-54'
  if (age < 60) return '55-59'
  return '60+'
}

export function lookupHigh(table: ScoringTable, ag: AgeGroup, val: number): number {
  const rows = table[ag] ?? table['<25']
  for (const [t, p] of rows) {
    if (val >= t) return p
  }
  return 0
}

export function lookupLow(table: ScoringTable, ag: AgeGroup, val: number): number {
  const rows = table[ag] ?? table['<25']
  for (const [t, p] of rows) {
    if (val <= t) return p
  }
  return 0
}

export function lookupWHtR(ratio: number): number {
  for (const [t, p] of WHTR_TABLE) {
    if (ratio <= t) return p
  }
  return 0
}

export function getWhtrRiskLabel(ratio: number): { label: string; color: string } {
  if (ratio <= 0.49) return { label: 'Low Risk', color: 'var(--green)' }
  if (ratio <= 0.54) return { label: 'Moderate Risk', color: 'var(--accent)' }
  return { label: 'High Risk', color: 'var(--red)' }
}

export function toMMSS(secs: number): string {
  const m = Math.floor(secs / 60)
  const s = secs % 60
  return `${m}:${String(s).padStart(2, '0')}`
}

export function parseRunTime(m: string | number, s: string | number): number {
  return (parseInt(String(m)) || 0) * 60 + (parseInt(String(s)) || 0)
}

export function parsePlankTime(m: string | number, s: string | number): number {
  return (parseInt(String(m)) || 0) * 60 + (parseInt(String(s)) || 0)
}

/** PFRA composite category: ≥90 Excellent, ≥75 Satisfactory, else Unsatisfactory. */
export function compositeToCategory(composite: number): Category {
  if (composite >= 90) return 'EXCELLENT'
  if (composite >= 75) return 'SATISFACTORY'
  return 'UNSATISFACTORY'
}
